import imgLoad from "@/components/imgLoad";
import imgsUpload from "@/components/imgsUpload";
import baseUpload from "@/components/baseUpload";
import DecryptImg from "@/components/decrypt-img/index.vue";
// import globalUploader from '@/components/globalUploader

import cropper from "@/components/cropper";
export default (Vue) => {
  Vue.component("ImgLoad", imgLoad);
  Vue.component("ImgsUpload", imgsUpload);
  Vue.component("BaseUpload", baseUpload);
  Vue.component("Cropper", cropper);
  Vue.component("DecryptImg", DecryptImg);
  // Vue.component('GlobalUploader', globalUploader)
};
